export default __webpack_public_path__ + "static/media/tbtc.c7c3b112.svg";